<template>
    <div class="msp-impegno-detail mx-auto msp-fixed-container" >
    <template v-if="impegno">

      <v-app-bar :color="color()" class="msp-fixed-header" >
        <v-btn icon @click="dismissModal()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="deleteItem()">
          <v-icon>mdi-delete</v-icon>
        </v-btn>
        <msp-confirm ref="confirmDelete"></msp-confirm>
        <v-btn icon @click="finishImpegno()">
          <v-icon>mdi-check-bold</v-icon>
        </v-btn>
      </v-app-bar>

      <v-alert
        class="alert-toast"
        transition="scale-transition"
        :value="errorAlertVisible"
        type="error"
        dense
        >
        Salvataggio non riuscito.
      </v-alert>
      <v-container fluid class="msp-fixed-content">

        <v-card
        >
        <v-card-text>
        <v-dialog
        ref="dialog_data"
        v-model="editing.data"
        :return-value.sync="impegnoData"
        persistent
        width="290px"
        >
        <template v-slot:activator="{ on, attrs }">
        
          <v-text-field
            :value="formatCalendarDay(impegno.data)"
            label="Data inizio"
            prepend-icon="mdi-calendar"
            readonly
            v-bind="attrs"
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
          v-model="impegno.data"
          scrollable
          locale="it-it"
          :first-day-of-week="1"
          :title-date-format="titleDateFormat"
        >
          <v-spacer></v-spacer>

          <v-btn
            text
            color="primary"
            @click="editing.data = false"
          >
            Annulla
          </v-btn>
          <v-btn
            text
            color="primary"
            @click="$refs.dialog_data.save(impegno.data)"
          >
            OK
          </v-btn>
        </v-date-picker>
      </v-dialog>
      <v-dialog
      ref="dialog_data_fine"
        v-model="editing.data_fine"
        :return-value.sync="impegnoDataFine"
        persistent
        width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
        
          <v-text-field
            :value="formatCalendarDay(impegno.data_fine)"
            label="Data fine"
            prepend-icon="mdi-calendar"
            readonly
            v-bind="attrs"
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
          v-model="impegno.data_fine"
          scrollable
          locale="it-it"
          :first-day-of-week="1"
          :title-date-format="titleDateFormat"
        >
          <v-spacer></v-spacer>

          <v-btn
            text
            color="primary"
            @click="editing.data_fine = false"
          >
            Annulla
          </v-btn>
          <v-btn
            text
            color="primary"
            @click="$refs.dialog_data_fine.save(impegno.data_fine)"
          >
            OK
          </v-btn>
        </v-date-picker>
      </v-dialog>
      <v-row>
      <v-col
      cols=12
      sm=6
      >
      <i :class="'msp-icon-impegno-'+impegno.impegno_tipo_id"></i>
      <v-select
      :items="tipi"
      item-text="descrizione"
      item-value="id"
      :value="impegno.impegno_tipo_id" 
      v-model="impegno.impegno_tipo_id"
      label="Tipo di impegno"
      ></v-select>
      </v-col>
      <v-col
      cols=12
      sm=6
      >
      <v-textarea class="" v-model="impegno.descrizione" placeholder="Aggiungi le informazioni relative all'impegno utili per l'allenatore"></v-textarea>
      </v-col>
      </v-row>
      </v-card-text>
      </v-card>

      </v-container>
      

    </template>

    </div>


  </template>

    <script>

import mspConfirm from '@components/MspConfirm.vue';
import {_canEdit} from "@mixins/canEdit.js";
import allenamentoCalcoli from "@src/js/vue/mixins/allenamentoCalcoli.js";
import env from "@mixins/environment.js"

import loadImpegno from "@mixins/loadEvent.js"
import _api from "@mixins/api.js";
import tipi from "@cached/impegno_tipo.json";
import _cal from "@src/js/vue/mixins/calendario.js"

// Campi modificabili dell'impegno, per capire se ci sono modifiche non salvate
// (stessi campi del desktop, vedi serializzaImpegno in scheda_allenamento/options.js).
const serializzaImpegno = function (impegno) {
    if (!impegno) return null;
    return JSON.stringify(['data', 'data_fine', 'impegno_tipo_id', 'descrizione']
        .map(campo => String(impegno[campo] ?? '')));
};

export default {
    mixins: [
        allenamentoCalcoli,
        env,
    ],
    components: {
        mspConfirm,
    },
    props: [
        "calendar",
    ],
    data: function() {
        return {
            tipi,
            mode:'',
            impegnoData: null,
            impegnoDataFine: null,
            editing: {
                data: true,
                data_fine: false,
                titolo: false,
            },
            impegno: null,
            statoIniziale: null,
            salvataggioInCorso: false,
            errorAlertVisible: false,
        };
    },

    watch: {
        impegnoData: function (val) {
            this.impegno.data = val;
            if (val > this.impegno.data_fine) this.impegno.data_fine = this.impegno.data;
        },
        impegnoDataFine: function (val) {
            this.impegno.data_fine = val;
            if (val < this.impegno.data) this.impegno.data = this.impegno.data_fine;
        },
    },

    async beforeRouteEnter (to, from, next) {
        let id = to.params.id;
        if (!id) {
            // nuovo impegno: bozza solo locale, la riga su DB viene creata solo
            // con la conferma (vedi finishImpegno/createImpegno)
            next((vm)=>{
                const oggi = _cal.date2ymd();
                vm.impegno = {
                    data: oggi,
                    data_fine: oggi,
                    impegno_tipo_id: 4,
                    descrizione: '',
                };
                vm.init();
            });
            return;
        }
        let userCanEdit = await _canEdit(id);
        if (!userCanEdit) {
            next(false);
        } else if (!from.name) {
            next('calendario');
        } else {
            loadImpegno(id)
                .then((result)=>{
                    next((vm)=>{
                        if (result && result.success) {
                            let impegno = result.data.data;
                            // copia locale: le modifiche restano qui fino alla conferma
                            vm.impegno = Object.assign({}, impegno);
                            vm.$store.dispatch("calendario/updateEvent", {id: id, event: {data: impegno}});
                            vm.init();
                        } else {
                            vm.dismissModal();
                        }
                    })
                });
        }
    },

    computed: {
        isModificato: function () {
            return serializzaImpegno(this.impegno) !== this.statoIniziale;
        },
    },
    methods: {

        showError: function () {
            this.errorAlertVisible = true;
            setTimeout(()=>{this.errorAlertVisible = false;}, 3000);
        },

        async deleteItem() {
            // bozza mai salvata su DB: niente da cancellare, si chiude e basta
            if (!this.impegno.calendario_id) {
                this.dismissModal();
                return;
            }
            if (
                await this.$refs.confirmDelete.open(
                    "Elimina",
                    "Sei sicuro?"
                )
            ) {
                this.deleteConfirm();
                this.dismissModal();
            }
        },
        deleteConfirm() {
            this.$store.dispatch("calendario/deleteEvent", this.impegno.calendario_id);
        },

        updateDates: function (na) {
            let data = null;
            let data_fine = null;
            if (na.length > 0) {
                data = na[0];
            }
            if (na.length > 1) {
                data_fine = na[1];
            }
            if (data > data_fine) {
                [data, data_fine] = [data_fine, data];
            }
            this.impegno = Object.assign(this.impegno,
                {
                    data: data,
                    data_fine: data_fine,
                }
            );
        },
        titleDateFormat: function (date) {
            if (!date) {
                return "-";
            }
            return this.formatCalendarDay(date);

        },


        setParam: function (prop, value) {
            this.impegno[prop] = value;
        },

        submit: function ()
        {
            this.$emit("submit", this.impegno);
        },
        color: function () {
            return 'var(--col-grigio-chiarissimo)';
        },
        updateData: function (/*ev*/) { },
        dismissModal () {
            let debug_from = true;
            if(debug_from) {
                this.$router.go(-1);
            } else {
                this.$store.dispatch("calendario/setDialog", false);
            }
        },
        init: function () {
            this.editing.data = this.calendar;
            this.statoIniziale = serializzaImpegno(this.impegno);
        },

        // Crea l'evento su DB. L'endpoint di creazione non accetta la descrizione
        // (vedi api_add_impegno): i campi completi vengono scritti subito dopo da update().
        createImpegno: async function () {
            let url = this.api_base_url+"/api/v2/calendario.php?impegno";
            let data = {
                data: this.impegno.data,
                data_fine: this.impegno.data_fine,
                impegno_tipo_id: this.impegno.impegno_tipo_id,
            };
            const result = await _api(url, "POST", data);
            if (!(result && result.success)) return false;
            const event = result.data.event;
            this.impegno = Object.assign({}, event.data, {
                calendario_id: event.id,
                data: this.impegno.data,
                data_fine: this.impegno.data_fine,
                impegno_tipo_id: this.impegno.impegno_tipo_id,
                descrizione: this.impegno.descrizione,
            });
            await this.$store.dispatch("calendario/addEvent", {event: event.data, type: event.type});
            return true;
        },

        update: async function () {
            let data = this.impegno;
            let url = this.api_base_url+"/api/v2/calendario.php?evento="+this.impegno.calendario_id;
            const result = await _api(url, "PUT", data);
            if (!(result && result.success)) return false;
            this.$store.dispatch("calendario/updateEvent", {id: this.impegno.calendario_id, event: {data: this.impegno}});
            return true;
        },

        // Tasto di conferma: unico punto in cui l'impegno viene salvato. Se la creazione
        // riesce e l'aggiornamento no, la bozza resta associata alla riga creata: una
        // nuova conferma fa solo l'aggiornamento.
        finishImpegno: async function () {
            if (this.salvataggioInCorso) return;
            // impegno già salvato e non modificato: niente da scrivere
            if (this.impegno.calendario_id && !this.isModificato) {
                this.dismissModal();
                return;
            }
            this.salvataggioInCorso = true;
            let salvato;
            try {
                salvato = (this.impegno.calendario_id || await this.createImpegno())
                    && await this.update();
            } catch {
                salvato = false;
            } finally {
                this.salvataggioInCorso = false;
            }
            if (!salvato) {
                this.showError();
                return;
            }
            this.dismissModal();
        },
    }

}
    </script>

<style lang="scss">
.msp-impegno-detail {
  .alert-toast {
    position: fixed;
    bottom: 20px;
    left: 50%;
    width: 90%;
    transform: translate3d(-50%, 0, 0);
    z-index: 10;
  }
  .impegno-titolo {
    p {
      margin: 0;
      padding:0;
      line-height: 1;
    }
    .impegno-specialita {
      font-size: 0.8em;
    }
  }

  .v-app-bar {
    .v-toolbar__title {
      display: flex;
      align-items: center;
      line-height: 2em;
      [class*="msp-icon-sport-"] {
        font-size: 2em;
        margin-left: 0;
        margin-right: 20px;
      }
    }
  }
  .small {
    font-size: 10px;
  }
  .v-avatar {
    i {
      font-size: 80px;
    }

  }

  .scheda-toolbar {
    background-color: var(--color) !important;
    color: #fff;
  }

  .test-attivi {
    .zone {
      overflow-x: auto;
    }
  }
}

</style>
